import * as React from 'react';
import { cloneDeep } from 'lodash-es';
import { Observer, useLocalObservable } from 'mobx-react-lite';
import { observable } from 'mobx';

export interface ModalApiInstance<RecordType = any, ConfigType = any> {
  visible: boolean;
  data: RecordType | undefined;
  config: ConfigType;
  open: (params: ({ data?: RecordType } & ConfigType)) => void;
  close: () => any;
}

function useModal<RecordType = any, ConfigType = any>(Component: any)
  : [ModalApiInstance<RecordType, ConfigType>, React.FunctionComponent<any>] {
  // modal api 对象
  const store = useLocalObservable(() => ({
    visible: false,
    data: null,
    config: null,
    open(params: ({ data?: RecordType } & ConfigType) | undefined) {
      const { data, ...config } = params ?? {};
      this.visible = true;
      this.data = cloneDeep(data) ?? undefined;
      this.config = config as ConfigType;
    },
    close () {
      this.visible = false;
    }
  } as ModalApiInstance<RecordType, ConfigType>), {
    data: observable.shallow,
    config: observable.shallow,
  });

  // 弹窗插槽：可直接通过 modal api 控制显示隐藏
  const Slot: React.FunctionComponent<any> = React.useMemo(
    () =>
      (props) =>
        <Observer>
          {() => store.visible ? <Component modal={store} {...props} /> : null}
        </Observer>,
    [Component]
  );
  return [store, Slot];
}

export default useModal;
